import { render } from "./searchs.vue?vue&type=template&id=3703506a"
import script from "./searchs.vue?vue&type=script&lang=js"
export * from "./searchs.vue?vue&type=script&lang=js"

import "./searchs.vue?vue&type=style&index=0&id=3703506a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__